import { FunctionComponent as F, useState, useEffect  } from "react";
import { useSelector } from "react-redux";
import {
  Checkbox,
  FormControl,
  FormControlLabel } from "@mui/material";
import TextTooltip from "../UI/Tooltip/TextTooltip";
import { IState } from "../../core/store/store";
import { getPriceDropAlerts, updatePriceDropAlerts } from "../../core/http/user";



const PriceDropAlerts: F = () =>
{
  const user = useSelector((state: IState) => state.user);

  const [priceDropAlertsChecked, setPriceDropAlertsChecked] = useState<boolean>(false);

  const handleCheckboxChange = () =>
  {
    if(!user.email)
      return;

    updatePriceDropAlerts(!priceDropAlertsChecked);
    setPriceDropAlertsChecked(!priceDropAlertsChecked);
  };

  // http reqs for email reminder on page load
  useEffect(() =>
  {
    (async() =>
    {
      const priceDropAlerts = await getPriceDropAlerts();
      if(!priceDropAlerts)
        return;

      setPriceDropAlertsChecked(priceDropAlerts && Boolean(user.email));
    })();
  }, []);


  return(
    <TextTooltip lines={[
      "Sends an email alert if a price drop is detected for any product listing in your " +
      "protocols"]}>
      <FormControl component='fieldset' sx={{ width: '330px' }}>
        <FormControlLabel
          label='Email alert for supplement price drop'
          control={<Checkbox
            checked={priceDropAlertsChecked}
            onChange={handleCheckboxChange}
            inputProps={{ 'aria-label': 'controlled' }}/>}/>
      </FormControl>
    </TextTooltip>);
};

export default PriceDropAlerts;